import React, { Component } from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import IndexRoot from "../Index/IndexRoot"
import { globalHistory } from "@reach/router"
import { theme } from "../Shared/styles-global"
import { setThemeVars } from "../../util/theme-helper"
import GoogleAdSense from "../GoogleAdSense"
import ClientOnly from "../../hooks/ClientOnly"
import GoogleAdSenseSearch from "../GoogleAdSense/Search"


class SideBar extends Component{
  state = {
    isOpened:false,
    slug:null,
  }
  constructor(props){
    super(props);
    this.state={
      isOpened:false,
      slug:props.slug,
    }
  }
  toggle = ()=>{
    this.setState(state=>({isOpened:!state.isOpened}));
  }
  render(){
    return (
    <SideBarContainer>
      <SideBarContainerAside>
          <SideBarToggleButton onClick={this.toggle}>
            <div className={this.state.isOpened ? "hamburger active" : "hamburger"}>
              <span/><span/><span/>
            </div>
          </SideBarToggleButton>

          <nav className={this.state.isOpened?"shown":null}>
              <IndexRoot dir="/" target={this.state.slug} depth={1} prefix="sidebar"/>
          </nav>

          <h2><a href="https://manju-summoner.fanbox.cc/" rel="noopener noreferrer" target="_blank">開発者支援</a></h2>
          <a href="https://manju-summoner.fanbox.cc/" rel="noopener noreferrer" target="_blank">
            <img src="/pixivfanbox.png" style={{maxWidth:"100%", maxHeight:"100%"}}/>
          </a>
          
          <ClientOnly>
            <GoogleAdSenseSearch/>
          </ClientOnly>
      </SideBarContainerAside>
      <MainContainer>
        {this.props.children}
      </MainContainer>
    </SideBarContainer>
    );
  }
}

SideBar.propTypes = {
  children: PropTypes.node.isRequired,
}

export default SideBar

const SideBarContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 300px;
  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`
const MainContainer = styled.div`
  grid-row: 1;
  grid-column: 1;
  @media screen and (max-width: 900px) {
    grid-row: 2;
    grid-column: 1;
  }
  background: ${() => setThemeVars(theme.bgColorLight, theme.bgColorDark)};
  border-radius: 0.5rem;
  filter: drop-shadow(0px 0px 1px rgba(0,0,0,0.1));
`
const SideBarToggleButton=styled.div`
  user-select: none;
  position: relative;
  height:55px;
  width:55px;

  display:none;
  cursor: pointer;
  margin:0 0 0rem -1rem;
  :hover{
    background: ${()=>setThemeVars( "#ccc","#353437")};
  }

  @media screen and (max-width: 900px) {
    display:block !important;
  }
  
  .hamburger {
    display:block !important;
    width: 50px;
    height: 44px;

    transform: scale(0.4);
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
  }
  .hamburger span {
    position: absolute;
    left: 0;
    width: 100%;
    height: 4px;
    background-color: ${()=>setThemeVars( theme.fontColorLight,theme.fontColorDark)};
    border-radius: 4px;
  }
  .hamburger, .hamburger span {
    display: inline-block;
    transition: all .1s;
    box-sizing: border-box;
  }
  .hamburger span:nth-of-type(1) {
    top: 0;
  }
  .hamburger span:nth-of-type(2) {
    top: 20px;
  }
  .hamburger span:nth-of-type(3) {
    bottom: 0;
  }
  
  .hamburger.active span:nth-of-type(1) {
    -webkit-transform: translateY(20px) rotate(45deg);
    transform: translateY(20px) rotate(45deg);
  }
  .hamburger.active span:nth-of-type(2) {
    opacity: 0;
  }
  .hamburger.active span:nth-of-type(3) {
    -webkit-transform: translateY(-20px) rotate(-45deg);
    transform: translateY(-20px) rotate(-45deg);
  }
`
const SideBarContainerAside = styled.aside`
  grid-row: 1;
  grid-column: 2;

  @media screen and (max-width: 900px) {
    grid-column: 1;
    margin:-55px 1rem 0 1rem;
    pointer-events: none;
    >:nth-child(n){
      display:none;
      pointer-events: auto;
    }
  }
  margin:1rem 1rem 1rem 2rem;

  ul{
    margin-top:0.5rem;
    margin-left:1rem;
    list-style: none;
    li{
        font-size:1rem;
        padding:0.3rem 0rem;
        a:hover{
          color: ${()=>setThemeVars( theme.fontSubColorLight,theme.fontSubColorDark)};;
        }
    }
    .current:before{
        content: "";
        display: inline-block;
        border: 0.3em solid transparent;
        border-left-color: ${()=>setThemeVars( theme.fontColorLight,theme.fontColorDark)};
        position: absolute;
        margin-left: -0.8rem;
        margin-top: 0.4rem;
    }
  }
  >nav>ul{
    margin-top:0;
    margin-left:0;
    >li>a{
      font-weight:bold;
    }
    >li{
      font-size:1.1rem;
      padding:0.7rem 0rem;
      border-bottom:1px solid ${()=>setThemeVars( theme.separatorColorLight,theme.separatorColorDark)};
      >ul{
        margin-left:0;
      }
    }
  }
  .shown{
    display:block;
  }

  h2{
    font-size:1.1rem;
    padding:0.7rem 0rem;
  }
`
